
<div class="container  align-items-center">
    <!-- <div class="card card-container  "> -->
    <div class="card-header" [ngStyle]="{'background-color': onderneming?.kleur }">
    </div>
    <div class="">
        <div class="row">
            <h1 class="col-10 cardHeader card-title text-left"><strong>Cash voor lease fiets</strong></h1>
            <div class="col-2 text-right mt-2">
              <a class="backButton" [routerLink]="['/',onderneming.naam,'tools']">
                <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
              </a>
              
            </div>
           
          </div>
        <h6 class="card-subtitle mb-5 text-muted  mobileTussentitel text-left">Bereken hoeveel bruto u moet inleveren om een fiets te
            leasen.</h6>
        <div class="row">
            <div class="col-12">

                    <form class="row" [formGroup]="cash4BikeFormGroup" (ngSubmit)="onSubmit();">
                        <div class="col-md-6">
                            <h4 class="mb-4 col-md-6 underlineTitle">Gegevens</h4>

                            <div class="form-row">
                                <div class="form-group col-lg-6 col-md-12">
                                    <label class="font-weight-bold" for="maandelijkseLeasePrijs">LEASEPRIJS / MAAND</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">€</span>
                                        </div>
                                        <input formControlName="maandelijkseLeasePrijs" type="number"
                                            name="maandelijkseLeasePrijs" step="any" placeholder="0.00" min=0
                                            class="form-control" required>
                                    </div>
                                </div>
                                <!--Old parameters for more details-->
                                <!-- <div class="form-group col-lg-6 col-md-12">

                                    <label class="font-weight-bold" for="risicoBuffer">RISICO BUFFER / JAAR</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">€</span>
                                        </div>
                                        <input formControlName="risicoBuffer" type="number" value=0.00
                                            name="risicoBuffer" step="any" placeholder="0.00" min=0 class="form-control"
                                            required>
                                    </div>
                                </div> -->
                                <div class="form-group col-lg-6 col-md-12">

                                    <label class="font-weight-bold" for="administratiekost">ADMINISTRATIEKOST /
                                        JAAR</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">€</span>
                                        </div>
                                        <input formControlName="administratiekost" type="number" value=0.00
                                            name="administratiekost" step="any" placeholder="0.00" min=0
                                            class="form-control" required>
                                    </div>
                                </div>
                                <!--Old parameters for more details-->
                                <!-- <div class="form-group col-lg-6 col-md-12">
                                    <label class="font-weight-bold" for="variaBedrag">VARIA BEDRAG / JAAR</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">€</span>
                                        </div>
                                        <input formControlName="variaBedrag" type="number" value=0.00 name="variaBedrag"
                                            step="any" placeholder="0.00" min=0 class="form-control" required>
                                    </div>
                                </div> -->
                            </div>
                            
                        </div>
                        <div class="col-md-6">


                            <h4 class=" col-md-6 mb-4 underlineTitle">Parameters</h4>
                            <div class="form-row">
                                <!--Old parameters for more details-->
                                <!-- <div class="form-group col-lg-6">
                                    <label class="font-weight-bold"
                                        for="GroepsverzekeringPercentage">GROEPSVERZEKERING</label>
                                    <div class="input-group">
                                        <input formControlName="GroepsverzekeringPercentage" type="number" value=0.00
                                            name="GroepsverzekeringPercentage" step="any" placeholder="0.00" min=0
                                            class="form-control" required>
                                        <div class="input-group-append">
                                            <span class="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div> -->



                                <div class="form-group col-lg-12">
                                    <label class="font-weight-bold" for="patronaleRSZ">PATRONALE RSZ
                                        <i placement="top" ngbTooltip={{cash4Bike?.infoPatronaleRSZ}}
                                        class="fa  size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"  aria-hidden="true"></i>
                                    </label>
                                    <div class="input-group">
                                        <input formControlName="patronaleRSZ" type="number" value=0.00
                                            name="patronaleRSZ" step="any" placeholder="0.00" min=0 class="form-control"
                                            required>
                                        <div class="input-group-append">
                                            <span class="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>


                                <!--Old parameters for more details-->
                                <!-- <div class="form-group col-lg-12">
                                    <label class="font-weight-bold" for="aoPercentage">ARBEIDSONGEVALLEN
                                        VERZEKERING</label>
                                    <div class="input-group">
                                        <input formControlName="aoPercentage" type="number" value=0.00
                                            name="aoPercentage" step="any" placeholder="0.00" min=0 class="form-control"
                                            required>
                                        <div class="input-group-append">
                                            <span class="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-12 text-right">
                            <button type="submit" [disabled]="!cash4BikeFormGroup.valid"
                                class="btn btn-outline-secondary m-1">BEREKEN</button>
                        </div>

                    </form>
                
            </div>
            <div class="col-12  w-100 xMargin ">
                <div *ngIf="!calculate" class="d-flex text-center w-100 h-100 " style="min-width: auto; min-height: 6em;">
                    <div class="card-body d-flex align-items-center ">
                      <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
                    </div>
                  </div>

                <div *ngIf="calculate" class=" row w-100 d-flex h-100 my-auto mx-auto ">
                    <div class="table-responsive">

                        <table style="width:  100%;" class="table border">

                            <tbody>
                                <tr>
                                    <th class="col1" scope="row">Jaarlijkse leasekost</th>
                                    <td class="col2"><i placement="top"
                                            ngbTooltip={{cash4Bike?.tekstJaarlijkseLeaseKost}}
                                            class="fa color-tooltip-icon fa-question-circle " aria-hidden="true"></i></td>
                                    <td class="col3">{{resultaat.jaarlijkseLeasekost| currency:'EUR'| removeComma }}
                                    </td>
                                </tr>
                                <tr>
                                    <th class="col1" scope="row">Totale kost werkgever</th>
                                    <td class="col2"></td>
                                    <td class="col3">{{resultaat.totaleKostWerkgever| currency:'EUR'| removeComma}}</td>
                                </tr>
                                <tr>
                                    <th class="col1" scope="row">In te leveren bruto loon per maand</th>
                                    <td class="col2"></td>
                                    <td class="col3">{{resultaat.brutoloonPerMaand| currency:'EUR'| removeComma}}</td>
                                </tr>

                                <td colspan="3"><button colspan="3" class="btn w-100 " type="button"
                                        data-toggle="collapse" data-target="#collapseExample" aria-expanded="false"
                                        aria-controls="collapseExample">
                                        <div>
                                            <h3 class="d-inline-block">Details Resultaat </h3>
                                            <i class="fa fa-chevron-down d-inline-block float-right mt-2 mr-1"
                                                aria-hidden="true"></i>
                                        </div>

                                    </button>
                                    <div class="collapse" id="collapseExample">
                                        <div class="table-responsive">

                                            <table style="width:  100%;" class="table">

                                                <tr>
                                                    <th class="col1" scope="row">Bruto per jaar</th>
                                                    <td class="col2"><i placement="top"
                                                            ngbTooltip={{cash4Bike?.tekstBrutoPerJaar}}
                                                            class="fa  color-tooltip-icon fa-question-circle " aria-hidden="true"></i></td>
                                                    <td class="col3">
                                                        {{resultaat.brutoPerJaar|currency:'EUR'| removeComma}}</td>
                                                </tr>
                                                <tr>
                                                    <th class="col1" scope="row">Patronale RSZ</th>
                                                    <td class="col2"><i placement="top"
                                                            ngbTooltip={{cash4Bike?.tekstDetailsPatronaleRSZ}}
                                                            class="fa color-tooltip-icon fa-question-circle " aria-hidden="true"></i></td>
                                                    <td class="col3">
                                                        {{resultaat.patronaleRSZ| currency:'EUR'| removeComma}}</td>
                                                </tr>

                                                <!--Old parameters for more details-->
                                                <!-- <tr>
                                                    <th class="col1" scope="row">Kostprijs arbeidsongevallenverzekering
                                                    </th>
                                                    <td class="col2"><i placement="top"
                                                            ngbTooltip={{cash4Bike?.tekstArbeidsongevallen}}
                                                            class="fa color-tooltip-icon fa-question-circle " aria-hidden="true"></i></td>
                                                    <td class="col3">
                                                        {{resultaat.arbeidsongevallenverzekering|currency:'EUR'| removeComma}}
                                                    </td>
                                                </tr> -->
                                                <!-- <tr>
                                                    <th class="col1" scope="row">Kostprijs groepsverzekering
                                                    </th>
                                                    <td class="col2"><i placement="top"
                                                            ngbTooltip={{cash4Bike?.tekstGroepsverzekering}}
                                                            class="fa color-tooltip-icon fa-question-circle " aria-hidden="true"></i></td>
                                                    <td class="col3">
                                                        {{resultaat.groepsverzekering| currency:'EUR' | removeComma}}
                                                    </td>
                                                </tr> -->
                                                <tr class="table-secondary">
                                                    <th class="col1" scope="row">Totaal
                                                    </th>
                                                    <td class="col2"></td>
                                                    <td class="col3">
                                                        <strong>{{resultaat.totaal | currency:'EUR' | removeComma}}</strong>
                                                    </td>
                                                </tr>


                                            </table>
                                        </div>
                                    </div>


                            </tbody>
                        </table>

                        <!-- <div class="accordion" id="accordionExample">
                            <div class="card-header" id="headingOne">
                                <h5 class="mb-0">
                                    <button class="btn" type="button" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Details resultaat
                                    </button>
                                </h5>
                            </div>
                        </div> -->

                    </div>
                    
                    <!--Op aanvraag van besox: knop met "Vraag offerte aan" -->
                    <div   *ngIf="onderneming.naam == 'Besox'" class="w-100 horizontalCenter d-flex mb-3" >
                        <div class="  ">
                            <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag offerte aan</a>

                        </div>
                    </div>
            
                    
                </div>

                
            </div>
            
        </div>
        <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming?.kleur }"></div>
        <div class=" mt-4 row h-100">
            <p class="text-center mx-auto w-100 font-italic">
                {{dataService.cash4Bike?.tekstWaarschuwing }}
                
            </p>
        
            <p class="text-center mx-auto w-100 font-italic">
               
                {{dataService.onderneming?.algemeneWaarschuwing }}
            </p>
            
        </div>


    </div>

    <!-- </div> -->
</div>